import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import RetirementCalculatorHeader from './components/RetirementCalculatorHeader';
import CalculatorStatic from '../../401kCalculatorStatic/CalculatorStatic';
import PartnersSection from '../Home/components/PartnersSection';
import BlogSection from '../Home/components/BlogSection';
import HubNav from '../../ResourceHubPages/HubNav/HubNav';
import PageHeaders from '../../../Utils/PageHeaders';
import { Container } from '@mui/material';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '20px',
  },
}));

const RetirementCalculator = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HubNav/>
       <PageHeaders
          title="Free Retirement Calculator — AI-Powered, Location-Aware | Plootus"
          description="Use Plootus's free AI retirement calculator to find out how much you need to retire. Analyzes 30+ expense categories, your zip code, healthcare costs, and inflation — then connects to your 401k for personalized fund picks."
          keywords="find old 401k, lost retirement accounts, forgotten 401k, unclaimed retirement money, 401k search"
          ogTitle="Free AI Retirement Calculator — Know Your Number | Plootus"
          ogDescription="Find out exactly how much money you need to retire based on your location, spending habits, and goals. Free, AI-powered, no SSN required."
          ogUrl="https://www.plootus.com/retirement-calculator"
          canonicalUrl="https://www.plootus.com/retirement-calculator"
        />
      <RetirementCalculatorHeader />
      <Container maxWidth="lg">
        <CalculatorStatic 
          hideHelmet={true} 
          hideHeader={true} 
          customStyle={{ marginTop: '0px', marginBottom: '0px' }} 
        />
      </Container>
      <PartnersSection />
      <BlogSection />
    </div>
  );
};

export default RetirementCalculator;
